import { useContext } from 'react';

import { SalesforceContext } from '../context';

export const useSalesforceContext = () => {
  const salesforceContext = useContext(SalesforceContext);

  if (!salesforceContext)
    throw new Error('[SalesforceContext]: unexpected error');

  return salesforceContext;
};
